import * as React from 'react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import './settings-lang-drawer.scss';

interface LanguageOption {
    value: string;
    label: string;
}

export const SettingsLangDrawerComponent = () => {
    const {i18n} = useTranslation();
    const languages: LanguageOption[] = [
        {value: 'ca', label: 'Català'},
        {value: 'es', label: 'Castellano'},
        {value: 'en', label: 'English'},
    ];
    const [selectedLang, setSelectedLang] = useState<string>(i18n.language);

    const changeLanguage = (value: string) => {
        i18n.changeLanguage(value);
        setSelectedLang(value);
    };

    return (
        <div className="lang-content-drawer">
            {languages.map((lang, index) => (
                <div
                    key={index}
                    className={`language-item-drawer ${selectedLang === lang.value ? 'selected' : ''}`}
                    onClick={() => changeLanguage(lang.value)}
                    onKeyDown={() => changeLanguage(lang.value)}
                    role="button"
                    tabIndex={0}
                >
                    <span className="language-label">{lang.label}</span>
                    <span className={`language-radio ${selectedLang === lang.value ? 'checked' : ''}`}></span>
                </div>
            ))}
        </div>
    );
};
